import { removeHTMLTag } from "@/utils"
export default {
  methods: {
    setCurrentSmallContentFn(val) {
      const quesTypeID = this.currentQuestion.quesTypeID
      if (quesTypeID === 5) {
        this.currentQuestion.smallContent.forEach((item,index) =>{
          if(index!==val){
            this.setCurrentSmallContent(index)
          }
        })
      }
    },
    //点击题目区域，小题当前状态
    smallClick(smallIndex){
      this.$emit('getSmallIndex',smallIndex)
      this.$forceUpdate()
      this.setCurrentSmallContentFn(smallIndex)
    },
    // 插入所有编辑器内容
    setAllInnerHtml(currentQuestion) {
      if (this.currentQuestion.smallContent[0].quesTypeID === 4 || this.currentQuestion.smallContent[0].quesTypeID === 5) {
        this.$nextTick(() => {
          for(let i = 0; i<currentQuestion.smallContent.length; i++) {
            const curQues = currentQuestion.smallContent[i]
            let _html = curQues.attAnswer ? (curQues.userAnswer === null || curQues.userAnswer === '' ? curQues.attAnswer : curQues.userAnswer) : curQues.userAnswer
            const refName = 'hasChildAnswerArea' + curQues.questionID
            this.$refs[refName][0].innerHTML = (_html === null || _html === 'null') ? '' : _html
          }
          this.currentQuestionChange = false
        })
      }
    },
    // 插入编辑器内容
    setInnerHtml(curQues) {
      // debugger;
      this.setCurrentSmallContentFn()
      if (this.currentQuestion.smallContent[0].quesTypeID === 4 || this.currentQuestion.smallContent[0].quesTypeID === 5) {
        this.$nextTick(() => {
          let _html = curQues.attAnswer ? (curQues.userAnswer === null || curQues.userAnswer === '' ? curQues.attAnswer : curQues.userAnswer) : curQues.userAnswer
          const refName = 'hasChildAnswerArea' + curQues.questionID
          this.$refs[refName][0].innerHTML = (_html === null || _html === 'null') ? '' : _html
        })
      }
    },
    setCurrentSmallContent(smallIndex) {
      this.smallIndex = smallIndex
      if (this.currentQuestion.smallContent[0].quesTypeID === 4 || this.currentQuestion.smallContent[0].quesTypeID === 5) {
        if(this.timerMouseUP) {
          clearTimeout(this.timerMouseUP)
        }
        const refName = 'hasChildAnswerArea' + this.currentQuestion.smallContent[this.smallIndex].questionID
        let domInput = this.$refs[refName][0].innerHTML
        let answer = (domInput === '<br/>' ||domInput === '<br>'||domInput === '<br><br>'|| domInput === 'null' || domInput === null) ? '' : domInput
        let smallContent = this.currentQuestion.smallContent
        let attAnswer = smallContent[this.smallIndex].attAnswer

         //主观题带有attAnswer判断是否答题
        if(attAnswer){ // 说明有表格题
          const data = {
            isAnswer: null,
            attAnswer: attAnswer, // attAnswer 作为初始化的题目
            userAnswer: null,
            index: this.smallIndex
          }
          // 是否答题
          if(answer && (removeHTMLTag(attAnswer) != removeHTMLTag(answer))) {
            data.isAnswer = 1
            data.userAnswer = answer
          }
          this.$store.dispatch('setAttIsAns', data)
          this.$store.dispatch('setShortAttAns', data)
          this.$store.dispatch('setShortAns', data)
          // 有一道小题已答，则这道大题已答
          let isAnswer = smallContent.some(item => {
            return item.isAnswer
          })
          this.$store.dispatch('setIsAns', isAnswer ? 1 : 0)
        }else{
          const data = {
            isAnswer:answer?1:0,
            userAnswer: answer,
            index: this.smallIndex
          }

          this.$store.dispatch('setAttIsAns', data)
          this.$store.dispatch('setShortAns', data)

          let isAnswer = smallContent.some(item => {
            return item.userAnswer
          })
          this.$store.dispatch('setIsAns', isAnswer ? 1 : 0)
        }
      }
    }
  }
}
